<template>
  <v-ons-page>

    <v-ons-toolbar>
      <div class="left">
        <v-ons-back-button v-if="! $md"></v-ons-back-button>
        <v-ons-toolbar-button v-else @click="pageStack.pop()">
          <v-ons-icon icon="md-arrow-left" size="24px"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
      <div class="center">
        {{ pageLabel.title }} - {{ cultLabel }}
      </div>
      <div class="right">
        <v-ons-toolbar-button v-if="isEditable" @click="deleteVenteConfirm">
          <v-ons-progress-circular v-if="isSubmitDelete" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          <v-ons-icon v-else icon="trash"></v-ons-icon>
        </v-ons-toolbar-button>
      </div>
    </v-ons-toolbar>

    <div class="content">

      <img :src="negoceImg + '.png'" :srcset="negoceImg + '@2x.png 2x'" class="perfnegoce" />

      <app-error-msg v-if="! (negoceInfos && negoceInfos.horaires) && ! isEdit && (negoceInfos && negoceInfos.msg)"
                     :list="negoceInfos.msg.content" :title="negoceInfos.msg.title"
                     :bg-color="negoceInfos.msg.color" :is-hide-footer-msg="true">
      </app-error-msg>

      <app-error-msg :list="errorMsgList"></app-error-msg>

      <v-ons-list modifier="noborder perflist">

        <template v-if="isTech">

          <v-ons-list-item modifier="nodivider perfcours">
            <div class="center">Agriculteur</div>
            <div class="right">{{ clientInfos ? clientInfos.name : 'n.c.' }}</div>
          </v-ons-list-item>

          <v-ons-list-item v-if="clientInfos && clientInfos.societe" modifier="nodivider perfcours">
            <div class="center">Exploitation</div>
            <div class="right">{{ clientInfos.societe }}</div>
          </v-ons-list-item>

          <v-ons-list-item v-if="clientInfos && clientInfos.erp && vente.etat != 'contrat'" modifier="nodivider perfcours">
            <div class="center">Code tiers</div>
            <div class="right">{{ clientInfos.erp }}</div>
          </v-ons-list-item>

        </template>

        <v-ons-list-item v-else-if="clientInfos" modifier="nodivider perfcours">
          <div class="center">Exploitation</div>
          <div class="right">{{ clientInfos }}</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Campagne</div>
          <div class="right">{{ campagne }}</div>
        </v-ons-list-item>

        <v-ons-list-item modifier="nodivider perfcours">
          <div class="center">Culture</div>
          <div class="right">{{ cultLabel }}</div>
        </v-ons-list-item>

        <v-ons-list-item v-if="vente.label_prix" modifier="nodivider perfcours" :expandable="prixItemDetail.length" :expanded.sync="isShow.prixDetail">
          <div class="center">Type de contrat</div>
          <div class="right">
            {{ vente.label_prix }}
            <span v-if="prixItemDetail.length" class="list-item__expand-chevron"></span>
          </div>
          <div v-if="prixItemDetail.length" class="expandable-content">
            <v-ons-list modifier="noborder nopadding">
              <v-ons-list-item v-for="(detailItem, detailIndex) in prixItemDetail"
                                :key="'detail-' + detailIndex" modifier="perfcours">
                <div class="center">{{ detailItem.title }}</div>
                <div class="right">
                  <template v-for="(item, index) in detailItem.content">
                    {{ item }}
                    <br :key="'content-' + index">
                  </template>
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-for="(infosPrixItem, infosPrixIndex) in infosPrixList"
                          :key="'infos-prix-' + infosPrixIndex" modifier="perfcours">
          <div class="center">{{ infosPrixItem.title }}</div>
          <div class="right">
            <template v-for="(item, index) in infosPrixItem.content">
              {{ item }}
              <br :key="'content-' + index">
            </template>
          </div>
        </v-ons-list-item>

        <app-vente-tonne :vente-tonne="vente.tonne" :infos-reste="getContratInfos('reste')"></app-vente-tonne>

        <v-ons-list-item v-if="vente.prix !== ''" modifier="nodivider perfcours" :expandable="!!prixItemCours" :expanded.sync="isShow.prixActuel">
          <div class="center">
            {{ prixItemLabel }}
          </div>
          <div class="right">
            {{ vente.prix.toLocaleString('fr', { minimumFractionDigits: 2 }) }}&nbsp;€/t
            <span v-if="prixItemCours" class="list-item__expand-chevron"></span>
          </div>
          <div v-if="prixItemCours" class="expandable-content">
            <v-ons-list modifier="noborder nopadding">
              <v-ons-list-item modifier="perfcours">
                <div class="center">Prix actuel</div>
                <div class="right">
                  <div class="badge"
                        :class="{ 'badge-vert': prixItemCours.var > 0, 'badge-rouge': prixItemCours.var < 0 }">
                    {{ formatCoursDiff(prixItemCours.var) }}
                  </div>
                  <div style="width: auto"><!-- .badge + div : fixed with -->
                    {{ prixItemCours.val.toLocaleString('fr', { minimumFractionDigits: 2 }) }}&nbsp;€/t
                  </div>
                </div>
              </v-ons-list-item>
            </v-ons-list>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="isTech || vente.etat != 'demande'" modifier="nodivider perfcours">
          <div class="center">Date du contrat</div>
          <div class="right">{{ vente.date }}</div>
        </v-ons-list-item>

        <app-vente-id v-if="(isTech && vente.id) || contratInfosLink" :vente-id="displayIdVente(vente.id)" :infos-link="contratInfosLink">
        </app-vente-id>

        <v-ons-list-item v-if="vente.comment" modifier="nodivider perfcours">
          <div class="center">
            <div>
              Commentaire de l'agriculteur
              <br />
              «
              <i>
                <span v-for='(comment, index) in vente.comment.split("\n")' :key="index"><br v-if="index" />{{ comment }}</span>
              </i>
              »
            </div>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="vente.comment_tc" modifier="nodivider perfcours">
          <div class="center">
            <div>
              Commentaire du technicien
              <br />
              «
              <i>
                <span v-for='(comment, index) in vente.comment_tc.split("\n")' :key="index"><br v-if="index" />{{ comment }}</span>
              </i>
              »
            </div>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="vente.etat == 'contrat'" modifier="nodivider perfcours chevron" @click="showContratPdf">
          <div class="center">
            <v-ons-icon icon="file-download"></v-ons-icon>&nbsp;
            Afficher le contrat PDF
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="isEditable && vente.id && ! otp.isMissing" modifier="perfbutton">
          <v-ons-button modifier="quiet" @click="showVenteDemande">
            Modifier la {{ vente.etat == 'demande' ? 'demande' : 'vente' }}
          </v-ons-button>
        </v-ons-list-item>

        <v-ons-list-item v-if="isEdit && ! isTech && vente.etat != 'demande' && ! otp.isMissing"
                          modifier="nodivider label" expandable :expanded.sync="isShow.note">
          <div class="center">Ajouter une note personnelle</div>
          <div class="expandable-content">
            <textarea @click="$event.stopPropagation()" class="textarea textarea--transparent" rows="3" placeholder="Écrire ici..."
                      v-model="vente.note"></textarea>
          </div>
        </v-ons-list-item>

        <v-ons-list-item v-if="isShow.note" modifier="perfbutton">
          <v-ons-button modifier="quiet" @click="saveNote">
            Enregistrer la note
          </v-ons-button>
        </v-ons-list-item>

      </v-ons-list>

      <footer v-if="negoceInfos" class="footer--perfbutton">
        <template v-if="isTech">
          <v-ons-button v-if="vente.etat == 'demande' || otp.isMissing || ! isEdit" modifier="large--cta perflarge" @click="saveVente">
            {{ pageLabel.cta }}
            <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          </v-ons-button>
          <a v-if="clientInfos" href="#" @click="callClient(vente.client, clientInfos, 'vente negoce')">
            <v-ons-icon icon="fa-phone"></v-ons-icon>
            Appeler l'agriculteur
          </a>
        </template>
        <template v-else>
          <v-ons-button v-if="! isEdit || otp.isMissing" modifier="large--cta perflarge" @click="saveVente">
            {{ pageLabel.cta }}
            <v-ons-progress-circular v-if="isSubmit" :modifier="$mdModifier" indeterminate></v-ons-progress-circular>
          </v-ons-button>
          <app-call-negoce :negoce-infos="negoceInfos" track-infos="vente" :is-appro="refCulture == 'appros'"></app-call-negoce>
        </template>
      </footer>
      
    </div>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShow.otp">
      <template slot="title">
        Code SMS
      </template>
      Veuillez renseigner le code reçu par {{ clientContact }} pour valider la signature :
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input input-id="inputOtp" ref="inputOtp" v-model="otp.value" placeholder="Indiquez le code à 6 chiffres" @keyup-enter="closeKeyboard">
        </app-input>
      </v-ons-list>
      <p v-if="isShow.otpResend" style="margin: 0">
        <a href="#" @click="resendOTP">
          Renvoyer le code
          <v-ons-icon icon="redo" size="12px"></v-ons-icon>
        </a>
      </p>
      <template slot="footer">
        <v-ons-alert-dialog-button v-if="isOffline || otp.isSent" @click="closeVente(true)">Plus tard</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button v-else @click="isShow.otp = false">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="saveVente">Valider</v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

    <v-ons-alert-dialog :modifier="$mdModifier + ' perfbadge rowfooter'" :visible.sync="isShow.delete" cancelable>
      <template slot="title">
        Attention !
      </template>
      Êtes-vous sûr de vouloir refuser cette demande&nbsp;?
      <v-ons-list modifier="noborder nopadding transparent">
        <app-input v-model="vente.comment_tc" placeholder="Indiquez une raison" @keyup-enter="closeKeyboard"></app-input>
      </v-ons-list>
      <template slot="footer">
        <v-ons-alert-dialog-button @click="isShow.delete = false">Annuler</v-ons-alert-dialog-button>
        <v-ons-alert-dialog-button modifier="primal" @click="deleteVente">
          Refuser
        </v-ons-alert-dialog-button>
      </template>
    </v-ons-alert-dialog>

  </v-ons-page>
</template>

<script>
import mixinsCommons from '../mixins/commons.js';
import mixinsCours from '../mixins/cours.js';

import { store } from '../store.js';

import AppErrorMsg from '../partials/ErrorMsg.vue';
import AppInput from '../partials/Input.vue';
import AppCallNegoce from '../partials/CallNegoce.vue';
import AppVenteTonne from '../partials/VenteTonne.vue';
import AppVenteId from '../partials/VenteId.vue';

import AppVenteDemande from './VenteDemande.vue';
import AppContratPdf from './ContratPdf.vue';

export default {
  mixins: [mixinsCommons, mixinsCours],
  components: { AppErrorMsg, AppInput, AppCallNegoce, AppVenteTonne, AppVenteId },
  props: ['pageStack'],
  data() {
    return {
      negoceId: '',
      indexVente: -1,
      refCulture: '',
      refDestination: '',
      vente: {
        id: '',
        client: '',
        id_prix: '',
        label_prix: '',
        tonne: '',
        prix: '',
        comment: '',
        comment_tc: '',
        note: '',
        date: '',
        etat: '',
        infos_prix: {}
      },
      otp: {
        value: '',
        isMissing: null,
        isResend: false,
        isSent: false,
      },
      isShow: {
        prixDetail: false,
        prixActuel: false,
        note: false,
        otp: false,
        otpResend: false,
        delete: false
      },
      state: store.state,
      data: store.data
    };
  },
  computed: {
    user() {
      return this.state.user;
    },
    campagne() {
      return this.user.campagne;
    },
    strategie() {
      return this.user.ventes[this.refCulture][this.refDestination];
    },
    clientConnect() {
      return this.state.client;
    },
    nbFeuille() {
      return this.state.onboarding.nbFeuille;
    },
    referentiel() {
      return this.data.referentiel;
    },
    cultLabel(){
      return this.getCultLabel();
    },
    clientInfos() {
      if(this.negoceInfos){
        if(this.isTech){
          return this.getClientInfosTech(this.data.negoce.clients, this.vente.client);
        } else if(this.negoceInfos.clients) {
          return this.negoceInfos.clients[this.vente.client];
        }
      }
      return null;
    },
    clientContact() {
      return this.getClientContact(this.isTech ? this.clientInfos : this.user);
    },
    negoceDate() {
      return this.data.negoce.date;
    },
    negoceInfos() { // undefined si autre OS
      return this.getNegoceAcces(this.data.negoce.list, this.negoceId);
    },
    isTech() {
      return this.negoceInfos && this.negoceInfos.is_tech;
    },
    prixItem() {
      var listPrix = this.getListPrix(this.negoceInfos, this.refCulture, this.refDestination);
      for (let i = 0; i < listPrix.length; i++) {
        var prixItem = listPrix[i];
        if(prixItem.id == this.vente.id_prix){
          return prixItem;
        }
      }
    },
    isPrixDetail(){
      return ! (this.vente.etat == 'contrat' || (this.vente.etat == 'vente' && this.isEdit));
    },
    prixItemCours() {
      if(this.isPrixDetail && this.isTech && this.prixItem && this.prixItem.cours !== ''){
        return {
          val: this.prixItem.cours,
          var: this.prixItem.cours - this.vente.prix,
        }
      }
    },
    prixItemNull() {
      return this.prixItem && this.prixItem.cours === null;
    },
    infosPrixList() {
      var infosPrixList = [];
      if(this.prixItem){
        if(this.prixItem.infos_prix){
          for (let i = 0; i < this.prixItem.infos_prix.length; i++) {
            var infosPrixItem = this.prixItem.infos_prix[i];
            if(! (this.vente.infos_prix[infosPrixItem.id] == undefined || this.vente.infos_prix[infosPrixItem.id] === '')){
              var infosPrixItemValues = infosPrixItem.values ? infosPrixItem.values :
                (infosPrixItem.list ? this.negoceInfos.infos_prix[infosPrixItem.id].list[infosPrixItem.list] : null);
              if(infosPrixItemValues){
                for (let j = 0; j < infosPrixItemValues.length; j++) {
                  var infosPrixItemValue = infosPrixItemValues[j];
                  var infosPrixItemValueInfos = 
                    this.negoceInfos.infos_prix && 
                    this.negoceInfos.infos_prix[infosPrixItem.id] ?
                    this.negoceInfos.infos_prix[infosPrixItem.id].values[infosPrixItemValue.id] :
                    {};
                  if(infosPrixItemValue.id == this.vente.infos_prix[infosPrixItem.id]){
                    infosPrixList.push({
                      title: infosPrixItem.label,
                      content: [
                        infosPrixItemValue.label ? infosPrixItemValue.label : infosPrixItemValueInfos.label
                      ]
                    });
                    if(infosPrixItemValue.detail){
                      infosPrixList.push(...infosPrixItemValue.detail);
                    }
                    if(infosPrixItemValueInfos.detail){
                      infosPrixList.push(...infosPrixItemValueInfos.detail);
                    }
                  }
                }
              } else if(infosPrixItem.type == 'number') {
                infosPrixList.push({
                  title: infosPrixItem.label,
                  content: [this.vente.infos_prix[infosPrixItem.id].toLocaleString('fr') + ' ' + infosPrixItem.unit]
                });
              } else { // textarea text
                infosPrixList.push({
                  title: infosPrixItem.label,
                  content: this.vente.infos_prix[infosPrixItem.id].toString().split("\n")
                });
              }
            }
          }
        }
        if(this.prixItem.tonne_surface){
          infosPrixList.push({
            title: 'Surface',
            content: [this.vente.infos_prix.surface.toLocaleString('fr') + ' ha']
          });
          infosPrixList.push({
            title: 'Rendement prévisionnel',
            content: [this.vente.infos_prix.rendement.toLocaleString('fr') + ' q/ha']
          });
        }
      }
      return infosPrixList;
    },
    prixItemDetail() {
      var prixItemDetail = [];
      if(this.isPrixDetail && this.prixItem){
        if(this.prixItem.detail){
          if(prixItemDetail.length){
            var detailList = prixItemDetail.map(item => { return item.title });
            for (let i = 0; i < this.prixItem.detail.length; i++) {
              let detailItem = this.prixItem.detail[i];
              if(! detailList.includes(detailItem.title)){
                prixItemDetail.push(detailItem);
              }
            }
          } else {
            prixItemDetail.push(...this.prixItem.detail);
          }
        }
      }
      return prixItemDetail;
    },
    prixItemLabel() {
      if(this.isEdit && this.strategie.done[this.indexVente].base != undefined){
        return 'Base';
      } else if(this.prixItem && this.prixItem.input_label_prix) {
        return this.prixItem.input_label_prix;
      } else {
        return 'Prix';
      }
    },
    isEdit() {
      return this.indexVente > -1;
    },
    isEditable(){
      return this.isEdit && this.negoceInfos && ((this.isTech && this.vente.etat != 'contrat') || this.vente.etat == 'demande');
    },
    isValidationDemande(){
      return this.isTech && this.isEdit && this.vente.etat == 'demande';
    },
    isOffline(){
      if(! this.isTech || this.isEdit || this.otp.isSent){
        return false;
      }
      // TC creation 1er call
      if(! this.$ons.platform.isWebView() && ! (this.$ons.platform.isAndroid() || this.$ons.platform.isIOS())){ // webapp desktop
        return false;
      } else {
        return true;
      }
    },
    pageStackSplice(){
      return this.clientConnect.id ? 2 : 3;
    },
    pageLabel() {
      var label = {};
      var labelVente;
      if(this.vente.etat == 'demande') {
        label.title = 'Demande';
      } else if(this.prixItemNull){
        label.title = 'Engagement';
        label.toast = 'Engagement enregistré';
        labelVente = "l'engagement";
      } else {
        label.title = 'Vente';
        label.toast = 'Vente enregistrée';
        labelVente = 'la vente';
      }
      if(this.vente.etat == 'demande'){
        if(this.isTech){
          label.cta = 'Valider la demande';
          label.toast = 'Demande validée';
        } else { // forcément ! isEdit
          label.cta = 'Envoyer ma demande';
        }
      } else if(this.otp.isMissing){
        label.cta = 'Signer ' + labelVente;
      } else { // forcément isTech
        label.cta = 'Enregistrer ' + labelVente;
      }
      return label;
    },
    contratInfosLink() {
      return this.getContratInfos('link');
    }
  },
  methods: {
    setVenteOTP() {
      var vente = this.strategie.done[this.indexVente];
      this.setVente(vente);
      this.otp.isMissing = vente.otp_missing ? true : false;
    },
    async saveVente() {
      if(this.isSubmit) {
        return;
      }
      this.resetErrorMsgList();

      this.isSubmit = true;

      const body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        data: {}
      };
      for(const key in this.vente) {
        body.data[key] = this.vente[key];
      }
      if(this.isEdit) {
        body.index_vente = this.indexVente;
        body.id_vente = this.vente.id;
        if(this.isValidationDemande){
          delete body.data.tonne;
          delete body.data.prix;
        }
      }
      if(! this.isEdit || this.otp.isMissing){ // pour conserver le même hash
        body.data.negoce = this.negoceId;
        body.data.coop = this.negoceInfos.label;
      }

      if(this.negoceInfos.is_otp && ! this.isValidationDemande){
        if(! this.isShow.otp){
          const responseOTP = await this.sendOTP(body, this.isOffline);
          if(this.isOffline){
            store.state.user.ventes[this.refCulture][this.refDestination].done.push(body.data);
            this.ionicStorage.set('user', this.user);
            this.otp.isSent = true;
            this.isShow.otp = true;
            this.isSubmit = false;
          } else if(responseOTP){
            if(responseOTP.indexVente !== undefined){ // webapp desktop
              this.otp.isSent = true;
              this.indexVente = responseOTP.indexVente;
              this.setVenteOTP();
              this.isShow.otp = true;
              this.isSubmit = false;
            } else if(! responseOTP.error) { // bypass OTP
              if(this.isTech){
                this.closeVente();
              } else {
                this.closeDemande(responseOTP);
              }
            }
          } else {
            this.isShow.otp = true;
            this.isSubmit = false;
          }
          return;
        } else {
          if(! this.otp.value){
            this.setErrorMsgList('inputOtp', "Pour signer le contrat, vous devez renseigner le code reçu par SMS");
            this.isSubmit = false;
            return;
          }
          this.addVenteHash(body);
          body.otp = this.otp.value;
          this.isShow.otp = false;
          if(! this.isEdit && this.otp.isSent){
            const responseOTP = await this.sendOTP(body, false);
            if(responseOTP && responseOTP.indexVente !== undefined){
              this.indexVente = responseOTP.indexVente;
              this.setVenteOTP();
              body.index_vente = this.indexVente;
              body.id_vente = this.vente.id;
              this.addVenteHash(body);
            }
          }
          if(this.otp.isMissing){
            body.data.otp_missing = false;
          }
        }
      }

      let callPath = this.getPath(this.isTech ? '/negoce/vente' : '/negoce/demande')
      callPath += '&negoce_date=' + this.negoceDate;

      if (this.isOffline && ! this.negoceInfos.is_otp) {

        store.state.user.ventes[this.refCulture][this.refDestination].done.push(body.data);
        this.ionicStorage.set('user', this.user);

        body.timestamp = parseInt(new Date().getTime() / 1000);
        this.$emit('call-api', {
          call: {
            path: callPath,
            data: body,
            isBgFetch: true
          }
        });
        this.pageStack.length > this.pageStackSplice && this.pageStack.splice(this.pageStack.length - this.pageStackSplice, this.pageStackSplice);
        this.$showToast(this.pageLabel.toast);

      } else {

        var fetchInit = this.$getFetchInit();
        fetchInit.body = JSON.stringify(body);
        callPath = this.$apiDomain + callPath;
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          this.updateUserFromResponse(response.user);

          if(response.isMajNegoce){
            store.data.negoce.date = 0;
            this.ionicStorage.set('negoce', this.data.negoce);
            store.data.date = 0;
            this.ionicStorage.set('date', 0);
            this.$emit('update-if-needed');
          }

          if (this.isTech) {
            if(! this.isEdit || this.otp.isSent){
              this.pageStack.length > this.pageStackSplice && this.pageStack.splice(this.pageStack.length - this.pageStackSplice, this.pageStackSplice);
            } else {
              this.pageStack.length > 1 && this.pageStack.pop();
            }
            this.$showToast(this.pageLabel.toast);
            if(this.negoceInfos.respo && response.idVente){
              this.redirectContrat(response.idVente);
            }
          } else {
            // forcément !this.isEdit
            this.closeDemande(response);
          }
        } catch(error) {
          this.handleError(error);
        }
      }
    },
    closeVente(isOTPMissing) {
      this.pageStack.length > this.pageStackSplice && this.pageStack.splice(this.pageStack.length - this.pageStackSplice, this.pageStackSplice);
      this.$showToast(isOTPMissing ? this.pageLabel.title + ' en attente de validation' : this.pageLabel.toast);
    },
    closeDemande(response) {
      this.pageStack.length > 2 && this.pageStack.splice(this.pageStack.length - 2, 2);
      if (this.nbFeuille == 2) {
        store.state.onboarding.nbFeuille += 1;
        this.ionicStorage.set('onboarding', this.state.onboarding);
        this.sendTrackEvent('onboarding feuille ' + this.nbFeuille);
      }
      store.state.badge.refCulture = this.refCulture;
      store.state.badge.refDestination = this.refDestination;
      if(response.isContrat){
        store.state.badge.type = 'contrat';
      } else {
        store.state.badge.type = 'vente';
      }
    },
    saveNote() {
      var body = {
        id: this.user.id,
        date: this.user.date,
        ref_culture: this.refCulture,
        ref_destination: this.refDestination,
        data: this.vente.note
      };
      body.index_vente = this.indexVente;

      store.state.user.ventes[this.refCulture][this.refDestination].done[this.indexVente].note = this.vente.note;
      this.ionicStorage.set('user', this.user);

      this.$emit('call-api', {
        call: {
          path: this.getPath('/vente/note'),
          data: body
        }
      });

      this.pageStack.pop();
    },
    deleteVenteConfirm() {
      if(this.isTech && this.vente.etat == 'demande'){
        this.isShow.delete = true;
      } else {
        this.$ons.notification.confirm({
          modifier: this.$mdModifier,
          title: 'Attention !',
          message:
            'Êtes-vous sûr de vouloir supprimer cette '
            + (this.vente.etat == 'demande' ? 'demande' : 'vente')
            + ' ?',
          buttonLabels: ['Annuler', 'Supprimer'],
          cancelable: true,
          callback: function (index) {
            if (index === 1) { // -1 if canceled
              this.deleteVente();
            }
          }.bind(this)
        });
      }
    },
    async deleteVente() {
      this.isShow.delete = false;
      this.isSubmitDelete = true;

      if(! this.vente.id){
        
        let indexCurrent = this.strategie.done.reduce(function (sum, vente) {
          return sum + (vente.id ? 1 : 0);
        }, 0);
        let expectedPath = '/negoce/vente';
        if(this.negoceInfos.is_otp){
          expectedPath = '/negoce/otp';
        }
        const api = await this.ionicStorage.get('api');
        if(api){
          for (let i = 0; i < api.length; i++) {
            const call = api[i];
            if(call.path.split('?')[0] == expectedPath
            && call.data.id == this.user.id
            && call.data.ref_culture == this.refCulture
            && call.data.ref_destination == this.refDestination){
              if(indexCurrent == this.indexVente){
                api.splice(i, 1);
                i--;
                if(! api.length) {
                  store.state.api = 0;
                }
                await this.ionicStorage.set('api', api);
                break;
              } else {
                indexCurrent += 1;
              }
            }
          }
        }

        store.state.user.ventes[this.refCulture][this.refDestination].done.splice(this.indexVente, 1);
        this.ionicStorage.set('user', this.user);

        this.pageStack.length > 1 && this.pageStack.pop();

      } else {

        const call = {
          method: 'DELETE',
          path: this.getPath(this.isTech ? '/negoce/vente' : '/negoce/demande'),
          data: {
            id: this.user.id,
            date: this.user.date,
            ref_culture: this.refCulture,
            ref_destination: this.refDestination,
            index_vente: this.indexVente,
            id_vente: this.vente.id
          }
        };
        if(this.isTech && this.vente.etat == 'demande'){
          call.data.comment_tc = this.vente.comment_tc;
        }

        const fetchInit = this.$getFetchInit(call.method);
        fetchInit.body = JSON.stringify(call.data);
        const callPath = this.$apiDomain + call.path;
        try {
          const response = await this.handleRequest(callPath, fetchInit);

          this.updateUserFromResponse(response.user);

          if(response.isMajNegoce){
            store.data.negoce.date = 0;
            this.ionicStorage.set('negoce', this.data.negoce);
            store.data.date = 0;
            this.ionicStorage.set('date', 0);
            this.$emit('update-if-needed');
          }

          this.pageStack.length > 1 && this.pageStack.pop();

        } catch(error) {
            this.handleError(error, 'de la suppression');
        }
      }
    },
    showVenteDemande() {
      const negoceId = this.negoceId;
      const refCulture = this.refCulture;
      const refDestination = this.refDestination;
      const indexVente = this.indexVente;
      this.pageStack.push({
        extends: AppVenteDemande,
        data() {
          return {
            negoceId: negoceId,
            refCulture: refCulture,
            refDestination: refDestination,
            indexVente: indexVente
          }
        }
      });
    },
    showContratPdf() {
      var indexVente = this.indexVente;
      var refCulture = this.refCulture;
      var refDestination = this.refDestination;
      this.pageStack.push({
        extends: AppContratPdf,
        data() {
          return {
            indexVente: indexVente,
            refCulture: refCulture,
            refDestination: refDestination
          }
        }
      });
    }
  },
  created() {
    if(this.isEdit) {
      this.setVenteOTP();
    }
  },
  mounted() {
    if(this.prixItemCours){
      this.isShow.prixActuel = true;
    }
    if(! this.isEdit) {
      this.isShow.prixDetail = true;
    }
    if(this.vente.note) {
      this.isShow.note = true;
    }
  }
}
</script>